import { ActionTree } from 'vuex'
import { State as Root } from '.'
import zsb from '@/http/zsb'

export const actions: ActionTree<null, Root> = {
  /**
   * 发送验证码
   * @param data 表单数据
   */
  async sendCode(_, phone: string) {
    if (!phone) {
      throw new Error('手机号码不允许为空')
    }
    await zsb.post('/common/sendOpenIdBindCaptcha', { phone })
  },
  /**
   * 提交表单
   * @param data 表单数据
   */
  async submit(_, { phone, captcha, code }) {
    if (!phone) {
      throw new Error('手机号码不允许为空')
    }
    if (!captcha) {
      throw new Error('验证码不允许为空')
    }
    if (!code) {
      throw new Error('绑定失败，请重新打开页面尝试')
    }

    await zsb.post('/common/getOpenIdBind', { captcha, code, phone })
  }
}

export const namespaced = true
